import React from "react";
import { observer, inject } from "mobx-react";
import Container from "reactstrap/lib/Container";
import { AboutMe } from "ComponentsUI/Info";
import { PaddingBottom } from "ComponentsUI/Spacings";
import ProviderContacts from "./ProviderContacts";

@inject("ApplicationModel")
@observer
export default class ProviderFullInfo extends React.Component {
	render() {
		const {
			ApplicationModel: { text, windowSizeModel },
			providerForCard,
			seoData,
		} = this.props;

		let aboutWe = seoData?.aboutWEText || providerForCard?.texts?.about_we || "";
		let aboutWeTitle = !!seoData?.aboutWEText ? seoData?.aboutWETitle : "";

		// if (!!providerForCard?.texts?.about_we) {
		//     aboutWe = providerForCard.texts?.about_we;
		// }

		return (
			<Container>
				{!!aboutWe && (
					<PaddingBottom>
						<AboutMe
							title={aboutWeTitle}
							data={aboutWe}
							windowSizes={windowSizeModel.windowSizes}
							baseOffset={true}
							styleNone={true}
						/>
					</PaddingBottom>
				)}
				<PaddingBottom>
					<ProviderContacts
						seoBlock={this.props.seoBlock}
						providerForCard={providerForCard}
					/>
				</PaddingBottom>
			</Container>
		);
	}
}
